<div mat-dialog-content>
  <quill-editor placeholder="Requirements" [modules]="quillConfig" [(ngModel)]="data">
  </quill-editor>
  <div fxLayout="row" fxLayoutAlign="none center" fxLayoutGap="10px" fxLayout.xs="column" fxLayout.sm="column">
    <span class="controls-alignment"></span>
    <button mat-raised-button  class="controls-alignment" color="primary" type="button" [mat-dialog-close]='data'>Ok</button>
    <button mat-button class="controls-alignment" type="button" color="primary"
    type="button" (click)="close()">Close</button>
    <span class="controls-alignment"></span>
  </div>
</div>